import TabsPage, { tabsFromResources } from "features/TabsPage";
import { candidateResources } from "./candidateResources";

// One tab per campaign type, derived from the (hidden) candidacy resources — each tab renders
// that resource's list, while the resource itself stays registered (see app/resources.js)
// so its show/create routes keep working.
const candidacyTabs = tabsFromResources(candidateResources);

const CandidatesPage = () => (
  <TabsPage
    title="Кандидатури по кампании"
    tabs={candidacyTabs}
    placeholder="Изберете тип кампания, за да видите кандидатурите."
  />
);

export default CandidatesPage;
